<template>
    <form @submit.prevent="$emit('submit')" class="space-y-6">

        <h2 class="mb-4 text-lg">Session Date for new modules</h2>

        <template v-for="group in sessionGroups">
            <FormSection>

                <template #title>
                    Session Group starting <br> {{ getGroupDate(group) }}
                </template>

                <div class="space-y-4">
                    <template
                        v-for="(session, i) in getGroupSessions(group)"
                        :key="`${session.course_session_group_id}-${session.module_id}`">

                        <hr v-if="i !== 0">

                        <h3 class="mb-4">Module: {{ getModuleTitle(session) }}</h3>
                        <SessionDates :name="`course_sessions.${i}`" :session="session"/>

                    </template>
                </div>

                <InputError
                    v-if="form.hasError('course_sessions')"
                    :data-name="name"
                    :message="form.getError('course_sessions')"/>

                <template v-if="$slots.footer" #footer>
                    <slot name="footer"></slot>
                </template>
            </FormSection>
        </template>
    </form>
</template>

<script>

import FormSection from "@/Components/Form/FormSection.vue";
import SessionDates from "@/Pages/Admin/CourseSessionGroups/Components/SessionDates";
import InputError from "@/Components/Form/InputError";
import {sortBy} from "lodash";
import dayjs from "dayjs";


export default {

    name: "SessionDatesForm",

    props: {
        course: {
            type: Object,
            required: true
        },
        sessionGroups: {
            type: Array,
            required: true
        },
    },

    inject: ['form'],

    data() {
        return {}
    },

    components: {
        FormSection,
        SessionDates,
        InputError
    },

    methods: {
        getGroupDate(group) {
            const sessions = sortBy(group.sessions, (session) => dayjs(session.start))

            return dayjs(sessions[0].start).calendar(null, {
                sameDay: '[Today at] h:mm A',
                nextDay: '[Tomorrow at] h:mm A',
                nextWeek: 'dddd [at] h:mm A',
                sameElse: 'DD/MM/YYYY h:mm A'
            })
        },
        getGroupSessions(group) {
            return this.form.course_sessions.filter(item => item.course_session_group_id === group.id);
        },
        getModuleTitle(session) {
            const module = this.form.modules.find(item => item._id === session.module_id);

            return module.title;
        },
    },
};

</script>
